import { useEffect } from "react";
import { useAppDispatch } from "../../../store";
import { chatPageOpened } from "../../../store/slice/chat/chatSlice";

export const useChatOpen = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(chatPageOpened(true));
        return () => {
            dispatch(chatPageOpened(false));
        }
    },[]);
};